import { autobind } from 'core-decorators';
import { observable } from 'mobx';
import Services from '@src/services/general';

@autobind
class GlobalStore {
  @observable currentAccount;
  /**
   * 获取登录状态
   */
  async getLoginState() {
    await Services.getCurrentAccount()
      .then(data => {
        console.info('account:', data);
        if (data && data.account) {
          this.currentAccount = data.account;
        } else {
          this.currentAccount = '';
        }
      })
      .catch(err => {
        const errCode = err.serviceResponse.code;
        if (errCode !== -13403 /*未登录*/) {
          const errMsg = err.serviceResponse.message;
          alert(errMsg);
        }
      });
  }
  constructor() {
    this.getLoginState();
  }
}

const globalStore = new GlobalStore();
export default globalStore;



// WEBPACK FOOTER //
// ./src/mobx-store/root-store/global-store/index.js